export default __webpack_public_path__ + "static/media/sharing.dab127b7.svg";